import React,{ useState, useEffect } from 'react';
import { List, Card, Avatar, Button, Badge, Space, message, Empty, Spin } from 'antd';
import { LikeOutlined, MessageOutlined, CalendarOutlined, UserOutlined } from '@ant-design/icons';
import moment from 'moment';
import { size } from 'lodash';
import PostDetail from './PostDetail';
import { API_BASE_URL } from '../config';
import { Input } from 'antd';
const { Search } = Input;

// 创建子组件来处理每个列表项的数据请求
const PostItem = ({ item, currentUser, onLike, onPostClick }) => {
  const [itemData, setItemData] = useState(null);

  useEffect(() => {
    const fetchItemData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/database/more_information`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            vp_id: item.vp_id
          })
        });
        const data = await response.json();
        if (data) {
          setItemData(data);
          console.log("每个贴子的其它信息：",data);
        } else {
          message.error(data.message || '获取数据失败');
        }
      } catch (error) {
        message.error('请求失败');
        console.error('Error:', error);
      }
    };

    fetchItemData();
  }, [item.vp_id,item]);
  // 如果数据还未加载完成，显示加载状态
  if (!itemData) {
    return (
      <Card style={{ marginBottom: '16px' }}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="small" />
          <span style={{ marginLeft: '8px' }}>加载中...</span>
        </div>
      </Card>
    );
  }

  return (
    <Card 
      style={{ marginBottom: '16px', cursor: 'pointer' }}
      onClick={() => onPostClick(item.vp_id)}
      actions={[
        <Button 
          icon={<LikeOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onLike(item.vp_id);
          }}
          type={itemData.likes.some(like => like.userid === currentUser?.userId) ? "primary" : "text"}
        >
          {size(itemData.likes)}
        </Button>,
        <Button 
          icon={<MessageOutlined />} 
          type="text"
          onClick={(e) => e.stopPropagation()}
        >
          {size(itemData.comments)}
        </Button>
      ]}
    >
      <Space style={{ marginRight: '12px' }}>
        {/* <Avatar 
          size="large" 
          src={item.avatar} 
          icon={<UserOutlined />}
          alt={item.name}
        />
        <span style={{ fontSize: '13px' }}>{item.name}</span> */}
      </Space>
      <List.Item.Meta
        title={
          <Space>
            <span>{item.vp_title}</span>
          </Space>
        }
        description={
          <span>
            <CalendarOutlined style={{ fontSize: '12px', marginRight: '4px' }} />
            {moment(item.vp_datetime).format('YYYY-MM-DD HH:mm')}
          </span>
        }
      />
      {itemData.selectedUsers && size(itemData.selectedUsers) > 0 && (
        <div style={{ marginTop: '16px' }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>value之星：</div>
          <Space wrap>
            {itemData.selectedUsers.map((user, index) => (
              <Space key={user.userId||index} align="center" style={{ marginRight: '12px' }}>
                <Avatar 
                  size="small" 
                  src={user.avatar} 
                  icon={<UserOutlined />}
                  alt={user.name}
                />
                <span style={{ fontSize: '13px' }}>{user.name}</span>
                {user.title && (
                  <span style={{ fontSize: '12px', color: '#999' }}>({user.title})</span>
                )}
              </Space>
            ))}
          </Space>
        </div>
      )}
      <div style={{ marginTop: '10px',  display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <div dangerouslySetInnerHTML={{ __html: item.vp_content.replace(/<img[^>]*>/g, '') }} />
      </div>
      {size(itemData.likes) > 0 && (
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          <span>点赞的人：</span>
          {itemData.likes.slice(0, 3).map(like => (
            <Avatar 
              key={like.userId} 
              src={like.avatar} 
              alt={like.name}
              size="small"
              style={{ marginLeft: '4px' }}
            />
          ))}
          {size(itemData.likes) > 3 && (
            <span style={{ marginLeft: '4px' }}>等{size(itemData.likes)-3}人</span>
          )}
        </div>
      )}
    </Card>
  );
};

const PostList = ({ selectedPostId,onBack,onRefresh,scrollToComments,posts, currentUser, onLike, onPostClick}) => {
  const [postss, setPostss] = useState([]);
  
  useEffect(() => {
    setPostss(posts);
  }, [posts]);

  const onSearch = async (value) => {
    const response = await fetch(`${API_BASE_URL}/database/search_title`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            vp_title: value
        })
        });
        const data = await response.json();
        if(data){
          console.log("搜索结果：",data);
          setPostss(data);
        }else{
          message.error(data.message || '搜索失败');
        }
  };

  if (postss.length === 0) {
    return (
      <>
      <Space direction="vertical">
      <Search placeholder="Please enter title or value" onSearch={onSearch} style={{ width: 250, marginBottom: '12px' }} />
    </Space>
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <Empty description="暂无内容，快去发布第一条动态吧！" />
      </div>
      </>
    );
  }

  const selectedPost = postss.find(post => post?.vp_id === selectedPostId);

  return (
    <>
    {selectedPostId ? (
        <PostDetail
          post={selectedPost}
          currentUser={currentUser}
          onLike={onLike}
          onBack={onBack}
          onRefresh={onRefresh}
          scrollToComments={scrollToComments}
        />
        ) : (
          <>
          <Space direction="vertical">
            <Search placeholder="Please enter title or value" onSearch={onSearch} style={{ width: 250, marginBottom: '12px' }} />
          </Space>
          <List
            pagination={{
              onChange: page => {
                console.log(page);
              },
              pageSize: 5,
            }}
            itemLayout="horizontal"
            dataSource={postss}
            renderItem={item => (
              <PostItem 
                item={item} 
                currentUser={currentUser} 
                onLike={onLike} 
                onPostClick={onPostClick}
              />
            )}
          />
        </>
    )}
    </>
  );
};

export default PostList;